import { Component, OnInit, Input,} from '@angular/core';
import {archivosCompartidosService, correoService} from '../services/api-rest.service'
import { isNull } from 'util';

@Component({
    selector: 'adjuntar-archivos-mensaje',
    template: `
    <div class="contenedor-adjuntos">
            <div class="contenedor">
              <div class="adjunto cursor" *ngFor="let item of  filtrarArchivos()" title="{{item.name}}">
                <div class="adjunto-imagen">
                    <img [src]="iconoArchivo(item.type)" width="25px" class="icono" style="margin:auto">
                </div>
                <div style="position: relative;">
                    <div>
                        <div class="f-12 m-0">{{item.name | shorten: 23: '...'}}</div>
                        <div class="f-11 mb-0">{{item.size /1000000 | number}} MB</div>
                        <i 
                            class="fas fa-times cursor" 
                            style="position: absolute;right: 0px; padding: 2px;top:25px"
                            (click)="eliminar(item)"></i>
                    </div>
                </div>
              </div>
            </div>
            
    </div>
    `,
    providers:[archivosCompartidosService, correoService]
})

export class AdjuntarArchivosMensajeComponent implements OnInit{
    @Input() archivos:any[]=[]
    
    private extenciones:any[]=[]
    constructor(
        private archivosCompartidosService:archivosCompartidosService,
        private correoService:correoService
    ) { }
    
    ngOnInit() {
        this.getExtencion()
        
    }
    
    public filtrarArchivos(){
        return this.archivos.filter((x:any)=> x.estado == 1)
    }
    public iconoArchivo(extension:any){
        if(this.extenciones.length == 0) return 'assets/icon/icon_file/plantilla_on.png'
        let item = this.extenciones.find((x:any)=> x.extension == extension) 
        
        return (item != undefined) ? item.icono_on : this.extenciones.find((x:any)=> x.id == 0).icono_on
    }
    public eliminar(item:any){
        if(item.id == 0){
            let index = this.archivos.findIndex((x:any) => x.id  == item.id)
            this.archivos.splice(index,1)
        }else{
            item.estado=-99
        }
        
    }
    private getExtencion(){
        this.archivosCompartidosService.extencionesArchivos().subscribe(
            result=>{
                this.extenciones = result
            }
        )
    }
   
}


// WEBPACK FOOTER //
// ./src/app/shared/element/adjuntar-archivo-mensaje.component.ts